import { TransactionJsonModel } from '../../domain/stream/transaction/TransactionDomains';
import ValueFactory from '../../util/ValueFactory';
import { ComponentDependency } from '../../domain/ui/ComponentMetadata';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ChannelActions } from '../actions/ChannelActions';
import ComponentForm from '../../components/custom/rule/ComponentForm';
import ComponentRuleFactory from '../../util/ComponentRuleFactory';

export interface EventState {
  event: TransactionJsonModel;
  dependencies: ComponentDependency[];
  isUpdate: boolean;
  form: ComponentForm<TransactionJsonModel>;
}

const initialState: EventState = {
  event: ValueFactory.initializeEvent(),
  isUpdate: false,
  dependencies: [],
  form: new ComponentForm<TransactionJsonModel>(ValueFactory.initializeEvent(), ComponentRuleFactory.getChannel()),
};

export const transactionReducer = (state: EventState = initialState, action: ReduxBaseAction<any, ChannelActions>) => {
  switch (action.type) {
    case 'CHANGE_EVENT':
      return { ...state, event: action.payload, isDirty: true };
    case 'CHANGE_EVENT_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_EVENT':
      return {
        ...state,
        event: ValueFactory.initializeEvent(),
        isUpdate: false,
        dependencies: [],
        isDirty: false,
        form: new ComponentForm<TransactionJsonModel>(ValueFactory.initializeEvent(), ComponentRuleFactory.getChannel()),
      };
    case 'CHANGE_EVENT_DEPENDENCIES':
      return { ...state, dependencies: action.payload };
    case 'CHANGE_EVENT_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
